import React from 'react';

import { Container, Close, BorderContainer, CustomIframe } from './styles';

const VideoPopup = ({ togglePopup, link }) => {
  return (
    <BorderContainer onClick={togglePopup} id="menuClose">
      <Container>
        <CustomIframe src={link} />
      </Container>
      <Close id="menuClose">&times;</Close>
    </BorderContainer>
  );
};
export default VideoPopup;
